import { render, staticRenderFns } from "./mark-remark.vue?vue&type=template&id=59b5efcb&"
import script from "./mark-remark.vue?vue&type=script&lang=js&"
export * from "./mark-remark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports